<!-- 登录页 -->
<template>
       <div class="filmWrapMK">
        <div class="paymentLiMK">
          <div class="paymentListMK">
            <ul>
              <li>
                <div class="listContMK">
                  <em>刘健</em><b>13333333333</b>
                  <span><i class="iconfont iconlbsfill"></i>北京市朝阳区</span>
                </div>
                <div class="listWMK">
                  <div class="truMK L"><i class="iconfont iconround"></i>默认地址</div>
                  <div class="R">
                    <span><i class="iconfont iconpost"></i>编辑</span>
                    <span><i class="iconfont iconlajixiang"></i>删除</span>
                  </div>
                </div>
              </li>
              <li>
                <div class="listContMK">
                  <em>刘健</em><b>13333333333</b>
                  <span><i class="iconfont iconlbsfill"></i>北京市朝阳区</span>
                </div>
                <div class="listWMK">
                  <div class="truMK L"><i class="iconfont iconselectfill"></i>默认地址</div>
                  <div class="R">
                    <span><i class="iconfont iconpost"></i>编辑</span>
                    <span><i class="iconfont iconlajixiang"></i>删除</span>
                  </div>
                </div>
              </li>
            </ul>

          
          </div>
         

        </div>
        <div class="loginBtnMK" @click="login">+新增收货地址</div>
       </div>
    

</template>

<script>

export default {
  name: "login",
  data() {
     return {
       docslist:'',
       token:'',
      }
  },

  computed: {},


  methods: {

  }
};
</script>

<style lang="stylus">
@import '../../assets/css/layout.styl'
@import '../../assets/css/common.styl'
@import '../../assets/css/icon.css'

.filmWrapMK
 background #f5f5f5
 height 100%

 .paymentLiMK
  height auto
  width 100%
  margin 0 auto
  .paymentListMK
   li
    height 200px
    background #fff
    margin-bottom 15px
    .listContMK
     width calc(100% - 40px)
     margin 0 auto
     border-bottom 1px solid #d3d3d3
     padding 20px 0px
     span 
      display block
      color #d3d3d3
      font-size 18px 
      padding-top 15px
     i 
      vertical-align middle 
      font-size 20px
     em
      font-size 28px 
     b 
      font-style normal
      padding-left 20px
  .listWMK
    width calc(100% - 40px)
    margin 0 auto
    padding-top 25px
    font-size 18px 
    color #c1bbbd
    span 
     padding-left 20px
     i
      font-size 18px
    .truMK
     i
      font-size 20px    
.loginBtnMK
    width calc(100% - 150px)
    height 90px
    line-height 90px
    background $background
    border-radius 45px
    font-size 34px
    text-align center
    color:$color
    cursor pointer
    position absolute
    left:0
    right 0
    bottom 40px
    margin auto
.L
  float $floLeft
.R
  float $florRight     
</style>



// WEBPACK FOOTER //
// src/view/filmmaker/index.vue